/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import ArticlesCard from '../components/ArticlesCard';
import AuthorPosts from '../components/AuthorPosts';
import AuthorPreview from '../components/AuthorPreview';
import BenefitsBlock from '../components/BenefitsBlock';
import BenefitsBlockItem from '../components/BenefitsBlockItem';
import BlogHeader from '../components/BlogHeader';
import BlogOverviewAuthor from '../components/BlogOverviewAuthor';
import BlogOverviewContainerPreview from '../components/BlogOverviewContainerPreview';
import BlogOverviewMenu from '../components/BlogOverviewMenu';
import BreadCrumb from '../components/BreadCrumb';
import BurgerMenu from '../components/BurgerMenu';
import ConsultExpert from '../components/ConsultExpert';
import Contacts from '../components/Contacts';
import ContactUs from '../components/ContactUs';
import ContactUsBtn from '../components/ContactUsBtn';
import ContactUsForm from '../components/ContactUsForm';
import ContactUsModal from '../components/ContactUsModal';
import ContainerBlock from '../components/ContainerBlock';
import ContainerWithOneColumns from '../components/ContainerWithOneColumns';
import ContainerWithSidebar from '../components/ContainerWithSidebar';
import ContainerWithThreeColumns from '../components/ContainerWithThreeColumns';
import ContainerWithTwoColumns from '../components/ContainerWithTwoColumns';
import ContentBlock from '../components/ContentBlock';
import CookieBanner from '../components/CookieBanner';
import CTALink from '../components/CTALink';
import CtaRow from '../components/CtaRow';
import CurrentAuthor from '../components/CurrentAuthor';
import CustomerCard from '../components/CustomerCard';
import CustomerCardPresentation from '../components/CustomerCardPresentation';
import CustomerMapBlock from '../components/CustomerMapBlock';
import CustomerReview from '../components/CustomerReview';
import EventCard from '../components/EventCard';
import EventsFutureBlock from '../components/EventsFutureBlock';
import EventsPastBlock from '../components/EventsPastBlock';
import FactItem from '../components/FactItem';
import Filter from '../components/Filter';
import FilterDropdown from '../components/FilterDropdown';
import FilterMobile from '../components/FilterMobile';
import FollowUs from '../components/FollowUs';
import Footer from '../components/Footer';
import FooterTerms from '../components/FooterTerms';
import FullWidthImage from '../components/FullWidthImage';
import GlossaryHeader from '../components/GlossaryHeader';
import GlossaryOverviewContainer from '../components/GlossaryOverviewContainer';
import GlossaryOverviewMenu from '../components/GlossaryOverviewMenu';
import Header from '../components/Header';
import HeaderCurrentAuthor from '../components/HeaderCurrentAuthor';
import HeaderLinkItem from '../components/HeaderLinkItem';
import HighlightsItem from '../components/HighlightsItem';
import ImageBlock from '../components/ImageBlock';
import ImageGrid from '../components/ImageGrid';
import ImageGridItem from '../components/ImageGridItem';
import ImageSliderItem from '../components/ImageSliderItem';
import InsightsOverviewContainerPreview from '../components/InsightsOverviewContainerPreview';
import InsightsOverviewMenu from '../components/InsightsOverviewMenu';
import IntegrationsBlock from '../components/IntegrationsBlock';
import IntegrationsBlockItem from '../components/IntegrationsBlockItem';
import JssForm from '../components/JssForm';
import LinkIconItem from '../components/LinkIconItem';
import LinkItem from '../components/LinkItem';
import LinkRow from '../components/LinkRow';
import LinksBlock from '../components/LinksBlock';
import LocationBlock from '../components/LocationBlock';
import LocationGroup from '../components/LocationGroup';
import LocationItem from '../components/LocationItem';
import Logo from '../components/Logo';
import MenuSecondary from '../components/MenuSecondary';
import MiscTextBlock from '../components/MiscTextBlock';
import MiscTextBlockItem from '../components/MiscTextBlockItem';
import MoreCategories from '../components/MoreCategories';
import MoreFromAuthor from '../components/MoreFromAuthor';
import MoreFromCategoryOrPlatform from '../components/MoreFromCategoryOrPlatform';
import MorePlatform from '../components/MorePlatform';
import Navigation from '../components/Navigation';
import NewsCompany from '../components/NewsCompany';
import OurAwardsBlock from '../components/OurAwardsBlock';
import OurAwardsBlockItem from '../components/OurAwardsBlockItem';
import OurCustomers from '../components/OurCustomers';
import OurCustomerStoriesBlock from '../components/OurCustomerStoriesBlock';
import OurCustomerStoriesBlockItem from '../components/OurCustomerStoriesBlockItem';
import OurLocation from '../components/OurLocation';
import OurPlatformPartnersBlock from '../components/OurPlatformPartnersBlock';
import OurPlatformPartnersBlockItem from '../components/OurPlatformPartnersBlockItem';
import OurServices from '../components/OurServices';
import OurTeamBlock from '../components/OurTeamBlock';
import OurTeamBlockItem from '../components/OurTeamBlockItem';
import OurTechnology from '../components/OurTechnology';
import PostCard from '../components/PostCard';
import PostCardPresentation from '../components/PostCardPresentation';
import PostPreviewPresentation from '../components/PostPreviewPresentation';
import ProjectHighlights from '../components/ProjectHighlights';
import QuoteStories from '../components/QuoteStories';
import QuoteStory from '../components/QuoteStory';
import RelatedBlockStories from '../components/RelatedBlockStories';
import RelatedBlogpost from '../components/RelatedBlogpost';
import RelatedStories from '../components/RelatedStories';
import SearchInput from '../components/SearchInput';
import SearchResult from '../components/SearchResult';
import Service from '../components/Service';
import ServicesOverview from '../components/ServicesOverview';
import SideMenu from '../components/SideMenu';
import SliderSection from '../components/SliderSection';
import SocialButtons from '../components/SocialButtons';
import Socials from '../components/Socials';
import StepsBlock from '../components/StepsBlock';
import StepsBlockItem from '../components/StepsBlockItem';
import StoryCard from '../components/StoryCard';
import StoryCategoryAndPlatform from '../components/StoryCategoryAndPlatform';
import StoryNavigate from '../components/StoryNavigate';
import StoryOverviewContainerPreview from '../components/StoryOverviewContainerPreview';
import StoryOverviewMenu from '../components/StoryOverviewMenu';
import SuccessContactUsModal from '../components/SuccessContactUsModal';
import TechCard from '../components/TechCard';
import TechnologyHighlights from '../components/TechnologyHighlights';
import TechnologyOverview from '../components/TechnologyOverview';
import ToolsBlock from '../components/ToolsBlock';
import ToolsBlockItem from '../components/ToolsBlockItem';
import Twitter from '../components/Twitter';
import VideoBlock from '../components/VideoBlock';

const components = new Map();
components.set('ArticlesCard', ArticlesCard);
components.set('AuthorPosts', AuthorPosts);
components.set('AuthorPreview', AuthorPreview);
components.set('BenefitsBlock', BenefitsBlock);
components.set('BenefitsBlockItem', BenefitsBlockItem);
components.set('BlogHeader', BlogHeader);
components.set('BlogOverviewAuthor', BlogOverviewAuthor);
components.set('BlogOverviewContainerPreview', BlogOverviewContainerPreview);
components.set('BlogOverviewMenu', BlogOverviewMenu);
components.set('BreadCrumb', BreadCrumb);
components.set('BurgerMenu', BurgerMenu);
components.set('ConsultExpert', ConsultExpert);
components.set('Contacts', Contacts);
components.set('ContactUs', ContactUs);
components.set('ContactUsBtn', ContactUsBtn);
components.set('ContactUsForm', ContactUsForm);
components.set('ContactUsModal', ContactUsModal);
components.set('ContainerBlock', ContainerBlock);
components.set('ContainerWithOneColumns', ContainerWithOneColumns);
components.set('ContainerWithSidebar', ContainerWithSidebar);
components.set('ContainerWithThreeColumns', ContainerWithThreeColumns);
components.set('ContainerWithTwoColumns', ContainerWithTwoColumns);
components.set('ContentBlock', ContentBlock);
components.set('CookieBanner', CookieBanner);
components.set('CTALink', CTALink);
components.set('CtaRow', CtaRow);
components.set('CurrentAuthor', CurrentAuthor);
components.set('CustomerCard', CustomerCard);
components.set('CustomerCardPresentation', CustomerCardPresentation);
components.set('CustomerMapBlock', CustomerMapBlock);
components.set('CustomerReview', CustomerReview);
components.set('EventCard', EventCard);
components.set('EventsFutureBlock', EventsFutureBlock);
components.set('EventsPastBlock', EventsPastBlock);
components.set('FactItem', FactItem);
components.set('Filter', Filter);
components.set('FilterDropdown', FilterDropdown);
components.set('FilterMobile', FilterMobile);
components.set('FollowUs', FollowUs);
components.set('Footer', Footer);
components.set('FooterTerms', FooterTerms);
components.set('FullWidthImage', FullWidthImage);
components.set('GlossaryHeader', GlossaryHeader);
components.set('GlossaryOverviewContainer', GlossaryOverviewContainer);
components.set('GlossaryOverviewMenu', GlossaryOverviewMenu);
components.set('Header', Header);
components.set('HeaderCurrentAuthor', HeaderCurrentAuthor);
components.set('HeaderLinkItem', HeaderLinkItem);
components.set('HighlightsItem', HighlightsItem);
components.set('ImageBlock', ImageBlock);
components.set('ImageGrid', ImageGrid);
components.set('ImageGridItem', ImageGridItem);
components.set('ImageSliderItem', ImageSliderItem);
components.set('InsightsOverviewContainerPreview', InsightsOverviewContainerPreview);
components.set('InsightsOverviewMenu', InsightsOverviewMenu);
components.set('IntegrationsBlock', IntegrationsBlock);
components.set('IntegrationsBlockItem', IntegrationsBlockItem);
components.set('JssForm', JssForm);
components.set('LinkIconItem', LinkIconItem);
components.set('LinkItem', LinkItem);
components.set('LinkRow', LinkRow);
components.set('LinksBlock', LinksBlock);
components.set('LocationBlock', LocationBlock);
components.set('LocationGroup', LocationGroup);
components.set('LocationItem', LocationItem);
components.set('Logo', Logo);
components.set('MenuSecondary', MenuSecondary);
components.set('MiscTextBlock', MiscTextBlock);
components.set('MiscTextBlockItem', MiscTextBlockItem);
components.set('MoreCategories', MoreCategories);
components.set('MoreFromAuthor', MoreFromAuthor);
components.set('MoreFromCategoryOrPlatform', MoreFromCategoryOrPlatform);
components.set('MorePlatform', MorePlatform);
components.set('Navigation', Navigation);
components.set('NewsCompany', NewsCompany);
components.set('OurAwardsBlock', OurAwardsBlock);
components.set('OurAwardsBlockItem', OurAwardsBlockItem);
components.set('OurCustomers', OurCustomers);
components.set('OurCustomerStoriesBlock', OurCustomerStoriesBlock);
components.set('OurCustomerStoriesBlockItem', OurCustomerStoriesBlockItem);
components.set('OurLocation', OurLocation);
components.set('OurPlatformPartnersBlock', OurPlatformPartnersBlock);
components.set('OurPlatformPartnersBlockItem', OurPlatformPartnersBlockItem);
components.set('OurServices', OurServices);
components.set('OurTeamBlock', OurTeamBlock);
components.set('OurTeamBlockItem', OurTeamBlockItem);
components.set('OurTechnology', OurTechnology);
components.set('PostCard', PostCard);
components.set('PostCardPresentation', PostCardPresentation);
components.set('PostPreviewPresentation', PostPreviewPresentation);
components.set('ProjectHighlights', ProjectHighlights);
components.set('QuoteStories', QuoteStories);
components.set('QuoteStory', QuoteStory);
components.set('RelatedBlockStories', RelatedBlockStories);
components.set('RelatedBlogpost', RelatedBlogpost);
components.set('RelatedStories', RelatedStories);
components.set('SearchInput', SearchInput);
components.set('SearchResult', SearchResult);
components.set('Service', Service);
components.set('ServicesOverview', ServicesOverview);
components.set('SideMenu', SideMenu);
components.set('SliderSection', SliderSection);
components.set('SocialButtons', SocialButtons);
components.set('Socials', Socials);
components.set('StepsBlock', StepsBlock);
components.set('StepsBlockItem', StepsBlockItem);
components.set('StoryCard', StoryCard);
components.set('StoryCategoryAndPlatform', StoryCategoryAndPlatform);
components.set('StoryNavigate', StoryNavigate);
components.set('StoryOverviewContainerPreview', StoryOverviewContainerPreview);
components.set('StoryOverviewMenu', StoryOverviewMenu);
components.set('SuccessContactUsModal', SuccessContactUsModal);
components.set('TechCard', TechCard);
components.set('TechnologyHighlights', TechnologyHighlights);
components.set('TechnologyOverview', TechnologyOverview);
components.set('ToolsBlock', ToolsBlock);
components.set('ToolsBlockItem', ToolsBlockItem);
components.set('Twitter', Twitter);
components.set('VideoBlock', VideoBlock);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
